import { Link } from "react-router-dom";
import Ico from "./Icons";
import { WHATSAPP_NUMBER, CONTACT_PHONE_HREF, CONTACT_PHONE_DISPLAY, CONTACT_EMAIL } from "../data/site";

const WHATSAPP_MESSAGE = "Bonjour 👋 je viens de votre site internet, je voulais des informations concernant : ";
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export default function Footer() {
  return (
    <>
    <a
      className="wabtn"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Discuter sur WhatsApp"
      title="Discuter sur WhatsApp"
    >
      <Ico name="whatsapp" size={27} color="#fff" />
    </a>
    <footer id="contact">
      <div className="ftop">
        <div className="fbrand">
          <div className="flogowrap">
            <img src="/Logo_LayeTech_Lateral.png" alt="" className="flogo" onError={e => e.target.style.display = "none"} />
          </div>
          <p>Innovation & Services Numériques — Votre partenaire pour la transformation digitale à Dakar et au Sénégal.</p>
          <div className="socials">
            {[["fb", "Facebook"], ["ig", "Instagram"], ["li", "LinkedIn"]].map(([ico, lbl]) => (
              <a href="#" key={ico} className="socbtn" aria-label={lbl}><Ico name={ico} size={15} /></a>
            ))}
          </div>
        </div>
        <div className="fcol">
          <h4>Navigation</h4>
          <Link to="/services"><Ico name="arrowR" size={10} />Services</Link>
          <Link to="/packs"><Ico name="arrowR" size={10} />Packs</Link>
          <Link to="/realisations"><Ico name="arrowR" size={10} />Réalisations</Link>
          <Link to="/a-propos"><Ico name="arrowR" size={10} />À propos</Link>
          <Link to="/contact"><Ico name="arrowR" size={10} />Contact</Link>
        </div>
        <div className="fcol">
          <h4>Services</h4>
          <Link to="/services/depannage-maintenance"><Ico name="arrowR" size={10} />Maintenance IT</Link>
          <Link to="/services/creation-sites-web"><Ico name="arrowR" size={10} />Sites Web</Link>
          <Link to="/services/google-business"><Ico name="arrowR" size={10} />Google Business</Link>
          <Link to="/services/marketing-digital"><Ico name="arrowR" size={10} />Marketing Digital</Link>
          <Link to="/services/logiciel-gestion"><Ico name="arrowR" size={10} />Logiciel de gestion</Link>
        </div>
        <div className="fcol">
          <h4>Contact</h4>
          <a href={CONTACT_PHONE_HREF}><Ico name="phone" size={12} />{CONTACT_PHONE_DISPLAY}</a>
          <a href={`mailto:${CONTACT_EMAIL}`}><Ico name="mail" size={12} />{CONTACT_EMAIL}</a>
          <a href="#"><Ico name="pin" size={12} />Dakar, Sénégal</a>
        </div>
      </div>
      <div className="fbot">
        <span>© 2026 LayeTech Informatique. Tous droits réservés.</span>
        <span>Fait avec ♥ par LayeTech que pour vous</span>
      </div>
    </footer>
    </>
  );
}